var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMaximize1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    rx: 9,
    fill: "#F3F3F3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.39773 4C9.05255 4 8.77273 4.27983 8.77273 4.625C8.77273 4.97017 9.05255 5.25 9.39773 5.25H11.8661L5.25 11.8661V9.39773C5.25 9.05255 4.97017 8.77273 4.625 8.77273C4.27983 8.77273 4 9.05255 4 9.39773V13.2917C4 13.6828 4.31713 14 4.70833 14H8.60227C8.94745 14 9.22727 13.7202 9.22727 13.375C9.22727 13.0298 8.94745 12.75 8.60227 12.75H6.13388L12.75 6.13388V8.60227C12.75 8.94745 13.0298 9.22727 13.375 9.22727C13.7202 9.22727 14 8.94745 14 8.60227V4.70833C14 4.31713 13.6828 4 13.2917 4H9.39773Z",
    fill: "#212121"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaximize1);
export default __webpack_public_path__ + "static/media/Maximize-1.7f40030aaead2128ef1fd5aff65acdfc.svg";
export { ForwardRef as ReactComponent };